import { SafeCollector3ss0wp8n80f6m as SafeCollector } from './internal/SafeCollector.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from './FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { fuseSharedFlow3r8bpddms9npl as fuseSharedFlow } from './SharedFlow.mjs';
import {
  fuse$default1n688ovh0h7ac as fuse$default,
  FusibleFlow2tgh9s2p1kryd as FusibleFlow,
} from './internal/ChannelFlow.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwKotlinNothingValueException2lxmvl03dor6f as throwKotlinNothingValueException } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function asSharedFlow(_this__u8e3s4) {
  return new (ReadonlySharedFlow())(_this__u8e3s4, null);
}
function onSubscription(_this__u8e3s4, action) {
  return new (SubscribedSharedFlow())(_this__u8e3s4, action);
}
var SubscribedFlowCollectorClass;
function SubscribedFlowCollector() {
  if (SubscribedFlowCollectorClass === VOID) {
    class $ {
      constructor(collector, action) {
        this.b1f_1 = collector;
        this.c1f_1 = action;
      }
      *d1f($completion) {
        // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
        // Inline function 'kotlin.js.getCoroutineContext' call
        var tmp$ret$0 = $completion.pc();
        var safeCollector = new (SafeCollector())(this.b1f_1, tmp$ret$0);
        try {
          yield* this.c1f_1(safeCollector, $completion);
        }finally {
          safeCollector.zc();
        }
        var tmp = this.b1f_1;
        if (tmp instanceof SubscribedFlowCollector())
          yield* this.b1f_1.d1f($completion);
        return Unit_instance;
      }
      *v1d(value, $completion) {
        yield* this.b1f_1.v1d(value, $completion);
        return Unit_instance;
      }
    }
    initMetadataForClass($, 'SubscribedFlowCollector', VOID, VOID, [FlowCollector()], [0, 1]);
    SubscribedFlowCollectorClass = $;
  }
  return SubscribedFlowCollectorClass;
}
var ReadonlySharedFlowClass;
function ReadonlySharedFlow() {
  if (ReadonlySharedFlowClass === VOID) {
    class $ {
      constructor(flow, job) {
        this.k1h_1 = flow;
        this.l1h_1 = job;
      }
      k1d(context, capacity, onBufferOverflow) {
        return fuseSharedFlow(this, context, capacity, onBufferOverflow);
      }
      *z1e(collector, $completion) {
        yield* this.k1h_1.z1e(collector, $completion);
        throwKotlinNothingValueException();
      }
      y1c(collector, $completion) {
        return this.z1e(collector, $completion);
      }
    }
    protoOf($).l1d = fuse$default;
    initMetadataForClass($, 'ReadonlySharedFlow', VOID, VOID, [FusibleFlow()], [1]);
    ReadonlySharedFlowClass = $;
  }
  return ReadonlySharedFlowClass;
}
var SubscribedSharedFlowClass;
function SubscribedSharedFlow() {
  if (SubscribedSharedFlowClass === VOID) {
    class $ {
      constructor(sharedFlow, action) {
        this.m1h_1 = sharedFlow;
        this.n1h_1 = action;
      }
      *z1e(collector, $completion) {
        yield* this.m1h_1.z1e(new (SubscribedFlowCollector())(collector, this.n1h_1), $completion);
        return throwKotlinNothingValueException();
      }
      y1c(collector, $completion) {
        return this.z1e(collector, $completion);
      }
    }
    initMetadataForClass($, 'SubscribedSharedFlow', VOID, VOID, VOID, [1]);
    SubscribedSharedFlowClass = $;
  }
  return SubscribedSharedFlowClass;
}
//region block: exports
export {
  SubscribedFlowCollector as SubscribedFlowCollector17ch8by19noql,
  asSharedFlow as asSharedFlow2buz3fbrowsyg,
  onSubscription as onSubscription3iwvbdmbwg7iq,
};
//endregion

//# sourceMappingURL=Share.mjs.map
